import { settings as raySettings } from '@wework/ray-core';
import WeGlide from 'client/javascript/we_glide/we_glide';
import { isFunction } from 'client/javascript/util/utils';
import throttle from 'lodash/throttle';

const DEFAULT_GLIDE_OVERRIDE_OPTIONS = {
  perView: 3,
  bound: true,
  breakpoints: {
    [raySettings.breakpointsInPixels.tablet]: {
      perView: 1,
      peek: {
        before: 0,
        after: 73.75
      },
      gap: 16
    },
    [raySettings.breakpointsInPixels.desktop]: {
      gap: 24,
      perView: 2
    }
  }
};

function isWindowWidthLessThanDesktop() {
  return window.innerWidth < raySettings.breakpointsInPixels.desktop;
}

function isWindowWidthLessThanTablet() {
  return window.innerWidth < raySettings.breakpointsInPixels.tablet;
}

class WeGlideAtBreakpoints {
  constructor(selector, { beforeMount, beforeUnmount }, options, mobileOnly) {
    this.selector = selector;
    this.beforeMount = beforeMount;
    this.beforeUnmount = beforeUnmount;
    this.mobileOnly = mobileOnly;
    this.options = options;

    const hasElementOnPage = Boolean(document.querySelector(this.selector));
    if (hasElementOnPage) {
      this.initializeGlide();
    }
  }

  mount() {
    if (isFunction(this.beforeMount)) {
      this.beforeMount();
    }

    this.glide = new WeGlide(this.selector, this.options);
    this.glide.mount();
  }

  unmount() {
    if (isFunction(this.beforeUnmount)) {
      this.beforeUnmount();
    }

    this.glide.destroy();
    this.glide = undefined;
  }

  initializeGlide() {
    let shouldMountGlideGallery;
    let shouldUnmountGlideGallery;
    if (this.mobileOnly) {
      shouldMountGlideGallery = !this.glide && isWindowWidthLessThanTablet();
      shouldUnmountGlideGallery = this.glide && !isWindowWidthLessThanTablet();
    } else {
      shouldMountGlideGallery = !this.glide && isWindowWidthLessThanDesktop();
      shouldUnmountGlideGallery = this.glide && !isWindowWidthLessThanDesktop();
    }

    if (shouldMountGlideGallery) {
      this.mount();
    } else if (shouldUnmountGlideGallery) {
      this.unmount();
    }
  }
}

function _beforeMount(glideSelector) {
  document.querySelector(glideSelector).classList.remove('ray-grid');
}

function _beforeUnmount(glideSelector) {
  document.querySelector(glideSelector).classList.add('ray-grid');
}

export default function setupWeGlideAtBreakpoints(
  { wrapperSelector, glideSelector },
  options = DEFAULT_GLIDE_OVERRIDE_OPTIONS,
  mobileOnly
) {
  const beforeMount = () => _beforeMount(glideSelector);
  const beforeUnmount = () => _beforeUnmount(glideSelector);
  const glideGallery = new WeGlideAtBreakpoints(wrapperSelector, { beforeMount, beforeUnmount }, options, mobileOnly);

  window.addEventListener('resize', throttle(glideGallery.initializeGlide.bind(glideGallery), 100));
}
